/**
 * The product name users see. Inlined at build time like every `NEXT_PUBLIC_*`
 * value, so rebranding is: set `NEXT_PUBLIC_BRAND_NAME`, then rebuild. Padding is
 * trimmed, and an unset, empty or blank value falls back to "Foresight", the same
 * rule as the backend's `app.brand_name`.
 */
const configuredBrandName = process.env.NEXT_PUBLIC_BRAND_NAME?.trim();

export const BRAND_NAME: string = configuredBrandName ? configuredBrandName : 'Foresight';
